<script>
  import { format } from 'svelte-i18n';

  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';
  import { Switch } from '@client/components/switch';
  import { Textarea } from '@client/components/textarea';

  export let id = null;
  export let label = null;
  export let html = null;
  export let text = null;
  export let regexp = null;
  export let clear = null;

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let readonly = false;
  export let editing = false;

  export let onUpdate = () => {};

  let newClearValue = clear;
  let newRegExpValue = regexp;
  let newTextValue = text;
  let newHtmlValue = html;
  let disableSubmit = true;

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;
    newTextValue = text;
    newHtmlValue = html;
    newClearValue = clear;
    newRegExpValue = regexp;
  };

  const onSave = () => {
    text = newTextValue;
    html = newHtmlValue;
    clear = newClearValue;
    regexp = newRegExpValue;

    editing = false;

    if (onUpdate) {
      onUpdate(id, label, {
        disclaimerhtml: html,
        disclaimertext: text,
        cleardisclaimer: clear,
        disclaimerenableregex: regexp
      });
    }
  };

  $: disableSubmit =
    text === newTextValue && html === newHtmlValue && newClearValue === clear && newRegExpValue === regexp;
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} />
  </FieldHeader>
  <FieldValue class="disclaimers">
    <div class="disclaimers-inner">
      {#if editing}
        <div>
          <Switch bind:checked={newClearValue} />
          <p>{$format('label.USE_REGULAR_EXPRESSION_PARSING')}</p>
          <Switch bind:checked={newRegExpValue} />
        </div>
        <div class="disclaimer-text">
          <p>{$format('label.TEXT').toUpperCase()}</p>
          <Textarea class="raw" id={`${id}-text`} bind:value={newTextValue} />
        </div>
        <div class="disclaimer-html">
          <p>{$format('label.HTML')}</p>
          <Textarea class="raw" id={`${id}-html`} bind:value={newHtmlValue} />
        </div>
      {:else}
        <div>
          {newClearValue ? $format('label.ENABLED') : $format('label.DISABLED')}
          <p>{$format('label.USE_REGULAR_EXPRESSION_PARSING')}</p>
          {newRegExpValue ? $format('label.ENABLED') : $format('label.DISABLED')}
        </div>
        <div class="disclaimer-text">
          <p>{$format('label.TEXT').toUpperCase()}</p>
          <span class="source">
            {newTextValue}
          </span>
        </div>
        <div class="disclaimer-html">
          <p>{$format('label.HTML')}</p>
          {@html newHtmlValue}
        </div>
      {/if}
    </div>
  </FieldValue>
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./disclaimers.scss"></style>
